import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomDataService } from 'src/app/services/custom-data.service';



@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  id
  constructor(private _Activatedroute:ActivatedRoute) 
  {
   
    
       // reset and set based on new parameter this time

  }


  ngOnInit() {
  }
  
  
}
